<template>
  <div class="container flex" style="padding-bottom: 20px;margin-top: 15px;">
    <div>
      <left></left>
    </div>
    <div class="live flex1" style="margin-left: 20px;background-color: #fff;">
    	<div class="title flex" style="padding: 10px;">
    		<span class="flex1">老师答疑</span>
    		<span style="color: #4fa7ff;cursor: pointer;" @click="handleAsk">去提问</span>
    	</div>
    	<div class="lists" v-for="item in list" @click="handleDetail(item.answerQuestionsId)">
    		<div class="listtile">
    			{{item.answerQuestionsTitle}}
    		</div>
 <!--   		<div class="list">
    			<span class="childName">初级经济法基础原题真题答案解析回顾</span>
    			<div class="viewWrap">
    				<span class="view">精华</span>
    			</div>
    			<div class="viewWrap">
    				<span class="view">查看</span>
    			</div>
    		</div>
    		<div class="list">
    			<span class="childName">初级经济法基础原题真题答案解析回顾</span>
    			<div class="viewWrap">
    				<span class="view">查看</span>
    			</div>
    		</div> -->
    	</div>





    </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          pageNo:1,
          pageSize:10000,
          list:[]
      }
    },
    methods:{
      handleAsk(){
        if(!window.sessionStorage.token){

          alert('请登录')

          return;
        }
        this.$router.push('submitquestion')
      },
      getData(){
        let data=new FormData();
            data.append('pageNo',this.pageNo);
            data.append('pageSize',this.pageSize);
        this.$axios.post(this.$common.questions_handpickQuestionsList,data).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data.list
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleDetail(id){
        this.$router.push({path:'questiondetail?id='+id})
      }
    },
    created(){
      this.getData();
    }
  }
</script>

<style scoped>
  .lists {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/teacheranswers.vue